module.exports = __webpack_public_path__ + "static/media/logo-header-117x72.8f5fa74c.png";